import Foundation from 'foundation-sites';

function quotePage() {
  const $categoryList = $('.product-category-checkboxset')
  const $categoryListItems = $categoryList.find('li.category-block')

  if (!$categoryList.length) {
    return
  }

  let $activeCategory = null
  let $activeList = null

  // Needs to match the max-width value for .category-block-label-wrapper
  const categoryLabelWidth = 150

  // Needs to match the block grid values of .product-category-checkboxset
  const gridRows = {
    small: 2,
    medium: 3,
    tablet: 4,
    large: 5,
    xlarge: 4,
    xxlarge: 5,
    verylarge: 5
  }

  $(window).on('resize', function() {
    if ($activeCategory && $activeList) {
      setTimeout(handleListOpen, 100)
    }
  });

  function getRow(index) {
    const currentGridRows = gridRows[Foundation.MediaQuery.current]
    const startOfNextRowIndex = index < currentGridRows ? currentGridRows : (currentGridRows + index) - (index % currentGridRows)

    return $categoryListItems.slice(startOfNextRowIndex, startOfNextRowIndex + currentGridRows)
  }

  function handleListOpen() {
    $categoryListItems.css('margin-top', 0)

    const currentGridRows = gridRows[Foundation.MediaQuery.current]
    const currentIndex = $activeCategory.index()

    // Set the new list width
    $activeList.css('width', $categoryList.width() - ($categoryList.width() - (currentGridRows * categoryLabelWidth)) / currentGridRows)

    // Get the next row based on the current index
    let $row = getRow(currentIndex)

    const isOpenBelow = $row.length
    const isOpenAbove = !$row.length

    let listHeight = $activeList.height()

    if (isOpenBelow) {
      $activeCategory.addClass('is-active--below')
      $row.css('margin-top', listHeight)
    }

    if (isOpenAbove) {
      // Get the previous row based on the index of an item in the previous row
      // Allows lists in the last row to be opened above
      $row = getRow(currentIndex - currentGridRows)
      $activeCategory.addClass('is-active--above')

      // 20 = height of arrow
      // 16 = half the padding on .is-active class
      const listOffset = $activeCategory.find('.category-block-label-wrapper').height() + 20 + 16
      $activeList.css('transform', `translateY(-${listOffset}px)`)

      $row.css('margin-top', listHeight)

      // Handle the offset visually for other items in this row
      // 16 = half the padding on .is-active class
      $row.not($activeCategory).css('margin-top', listHeight + 16)
    }
  }

  function handleListClose() {
    $categoryListItems.css('margin-top', 0)
    $categoryList.find('.is-active').removeClass('is-active is-active--below is-active--above')
  }

  function slideSubQuotes() {
    const $action = $('.js-category-action');

    // main on click function
    $action.on('click', function(e){
      var $this = $(this);
      $activeCategory = $this.closest('.js-category-block')
      $activeList = $activeCategory.find('.js-quote-sub-wrapper')

      e.stopPropagation();
      e.preventDefault();

      // this checks the blocks that do not have subcategories
      if($activeCategory.hasClass('js-no-subcategories')) {
        var labelID = $(this).attr('for');

        if($activeCategory.hasClass('has-checked-inputs')) {
          $activeCategory.removeClass('has-checked-inputs')
          $('#'+labelID).attr('checked', false);
        } else {
          $activeCategory.addClass('has-checked-inputs')
          $('#'+labelID).attr('checked', true);
        }
      // this is for blocks that contain subcategories
      } else {
        if ($activeCategory.hasClass('is-active')) {
          handleListClose()
          $activeCategory = null
          $activeList = null
        } else {
          handleListClose()
          handleListOpen()
          $activeCategory.addClass('is-active');
        }
      }
    });

    $('.product-category-checkboxset').on('change', '.subcategories input[type=checkbox]', function (e) {
      const hasChecked = $(this).closest('.subcategories').find('input[type=checkbox]').filter(':checked').length
      if(hasChecked) {
        $(this).closest('.js-category-block').addClass('has-checked-inputs')
      } else {
        $(this).closest('.js-category-block').removeClass('has-checked-inputs')
      }
    });

    // close x
    $('.js-close-quote').on('click', handleListClose)
  }

  slideSubQuotes();
}

quotePage();
